/**
 * @fileoverview Dashboard Index — redirect stub
 *
 * Purpose: `/dashboard` no longer has a page of its own. The old overview
 * (stats cards + recent jobs table) was removed once the Jobs list gained
 * Created / Last Activity columns and filtering, which covered the same need.
 *
 * This route is kept purely so `/dashboard` stays a valid destination:
 * marketing pages, the trust centre, the login and onboarding redirects, and
 * existing bookmarks all point here via `DashboardRoute.fullPath`. It sends
 * everyone straight to the Jobs list.
 *
 * URL: /dashboard → /dashboard/jobs
 * Protection: Requires authentication (inherited from the _auth layout)
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/jobs" });
  },
});
